module.exports = __webpack_public_path__ + "static/media/header-banner-preaproved.7b12bd2f.svg";